import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/page-metadata";
import ContractSign from "@/pages/ContractSign";
export const Route = createFileRoute("/sign/$token")({ head: ({match}) => pageHead(match.pathname), component: () => (<ContractSign />) });
